'use client';

import { Ref } from 'react';
import { IMaskInput } from 'react-imask';
import { Progress } from '../progress/progress';
import { inputLoading, phoneInputStyles } from './phone-input.css';
import { Phone } from 'lucide-react';

export const isValidPhoneNumber = (phone: string | undefined): boolean => {
  if (!phone) return false;
  const normalized = phone.replace(/\D/g, '');
  return normalized.length === 10;
};

export type PhoneInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'max' | 'min' | 'value'
> & {
  onChange?: (value: string) => void;
  loading?: boolean;
  value?: string;
  ref?: Ref<HTMLInputElement>;
};

export const PhoneInput = ({ onChange, loading, ref, ...props }: PhoneInputProps) => {
  return (
    <div style={{ position: 'relative' }}>
      <IMaskInput
        mask="(000) 000-0000"
        unmask={true}
        inputRef={ref}
        onAccept={(newValue) => onChange && newValue !== props.value && onChange(newValue)}
        {...props}
        disabled={props.disabled || loading}
        className={phoneInputStyles}
        type="tel"
      />
      <Phone size={16} style={{ position: 'absolute', top: '50%', marginTop: -8, left: 14 }} />
      {loading ? (
        <div className={inputLoading}>
          <Progress size={18} />
        </div>
      ) : null}
    </div>
  );
};
